import PropTypes from 'prop-types';
import { CommunicationStatusTypes } from '../../dashboard/constants';

export const messagePropTypes = {
  communicationId: PropTypes.number,
  title: PropTypes.string,
  name: PropTypes.string,
  bodyText: PropTypes.string,
  coverImage: PropTypes.string,
  status: PropTypes.oneOf([CommunicationStatusTypes.PUBLISHED, CommunicationStatusTypes.DRAFT]),
  publishedOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};
